// extracted by mini-css-extract-plugin
export default {"root":"menu-module--root--YpMww","active":"menu-module--active--T2kv2"};